

import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {
    id : any;
    column: string;
    instituteId: any;
};


export type historyRes = {
    history : any;
}
export const getHistory = (
    { id, column, instituteId}: requestDTO 
  ): Promise<historyRes> => {
    return axios.post(`/superadmin/history/funnel`, { id, column, instituteId});
  };

type UseAddUserOptions = {
  config?: MutationConfig<typeof getHistory>;
};

export const useGetHistory = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
    //   showNotification({
    //     type: 'success',
    //     title: 'Funnel created successfully',
    //   });
    },
    ...config,
    mutationFn: getHistory,
  });
};
